import { Path, useFormContext } from 'react-hook-form'

import { AbTestsCommonSchema } from 'features/ab-tests/forms/AbTestsCommonForm/abTestsCommonSchema'
import { RowDataVariant } from '../types'

type UseHideInput = {
  hideInput: (prefix: RowDataVariant['prefix']) => boolean
}

export const useHideInput = (): UseHideInput => {
  const { getValues } = useFormContext<AbTestsCommonSchema>()

  const hideInput = (prefix: RowDataVariant['prefix']): boolean => {
    type RelativePath = Path<NonNullable<AbTestsCommonSchema['variants']>[typeof variantKey]>

    const variantKey = prefix.split('.')[0] as keyof NonNullable<AbTestsCommonSchema['variants']>
    const relativePath = prefix.split('.').splice(1).join('.') as RelativePath

    switch (relativePath) {
      case 'viewabilityTools.lazyLoading.gamAdRenderMargin': {
        return (
          getValues(`variants.${variantKey}.viewabilityTools.lazyLoading.lazyLoadType`) ===
          'yieldbirdLazyLoad'
        )
      }
      case 'viewabilityTools.lazyLoading.kvTargetingAndPrebidAuction': {
        return (
          getValues(
            `variants.${variantKey}.viewabilityTools.lazyLoading.lazyLoadTargetingPrebidAuctionEnabled`,
          ) === false
        )
      }
      default: {
        return false
      }
    }
  }

  return { hideInput }
}
